import { useEffect, useCallback, useRef } from 'react';

const useResizeObserver = (ref, onResize) => {
    const callbackRef = useRef(onResize);
    const timeoutRef = useRef(null);
    
    // Update callback ref when onResize changes
    useEffect(() => {
        callbackRef.current = onResize;
    }, [onResize]);

    const debouncedCallback = useCallback((entries) => {
        // Clear any existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        
        // Debounce to prevent ResizeObserver loop
        timeoutRef.current = setTimeout(() => {
            for (let entry of entries) {
                if ((entry.target === ref) && callbackRef.current) {
                    callbackRef.current(entry.contentRect);
                }
            }
        }, 16); // ~60fps debouncing
    }, [ref]);

    useEffect(() => {
        if (!ref) return;

        const observer = new ResizeObserver(debouncedCallback);
        observer.observe(ref);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            observer.disconnect();
        };
    }, [ref, debouncedCallback]);
};

export default useResizeObserver;